import React from 'react';

const ChevronUp = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='8'
      viewBox='0 0 14 8'
      fill='none'
      {...props}
    >
      <path
        d='M12.9182 0H6.68848H1.07872C0.118766 0 -0.361211 1.15994 0.318756 1.83992L5.49853 7.01967C6.32849 7.84963 7.67843 7.84963 8.50839 7.01967L10.4783 5.04976L13.6881 1.83992C14.3581 1.15994 13.8781 0 12.9182 0Z'
        fill='#1B224C'
      />
    </svg>
  );
};

export default ChevronUp;
